export const getItemSelected = (state) => state.items.itemSelected;
export const getAllItemsData = (state) => state.items.allitems;
